import Swal from 'sweetalert2';

export const show = ({ title, text, icon }) => {
  return Swal.fire({
    title,
    text,
    icon,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
  });
};
